import { useQuery } from 'react-query';
import { AxiosResponse } from 'axios';

import { PATH } from '../../constants/global';
import { useAPI } from '..';

import { UseItemStatus, ItemStatus, ItemStatusRequest } from './useItemStatus.type';

export default (): UseItemStatus => {
    const request = useAPI();
    const { data, isLoading } = useQuery('item-statuses', getItemStatusesFromAPI);

    async function getItemStatusesFromAPI(): Promise<AxiosResponse<ItemStatusRequest>> {
        try {
            return await request.get(PATH.ITEM_STATUSES.LIST);
        } catch (error) {
            // TODO: handle errors better
            console.log(error);
        }
    }

    return {
        isLoading,
        list: data?.data?.Data || [] as ItemStatus[],
    }
}